import { Button, message, Tooltip } from 'antd';
import React from 'react';
import { formatMarkdownForCopy } from '../utils';
import { logger } from '@src/utils/misc/logger';
import { CopyOutlined } from '@ant-design/icons';
import { getSessionId } from '../NexaStore';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_RESPONSE_COPY } from '@src/utils/sensor/track';

export const CopyBtn = ({ value }) => {
  // Function to copy markdown text to clipboard
  const handleCopyMarkdown = async () => {
    try {
      if (value && typeof value === 'string') {
        const formattedMarkdown = formatMarkdownForCopy(value);
        await navigator.clipboard.writeText(formattedMarkdown);
        message.success('Copied to clipboard!');

        const id = getSessionId();
        apptracker(NEXA_RESPONSE_COPY, { id });
      }
    } catch (error) {
      logger.error('Failed to copy text:', error);
      message.error('Failed to copy text to clipboard');
    }
  };

  return (
    <Tooltip title="Copy">
      <Button
        type="text"
        size="small"
        icon={<CopyOutlined />}
        onClick={handleCopyMarkdown}
        title="Copy markdown text"
        style={{ marginLeft: '8px' }}
      />
    </Tooltip>
  );
};
